/**
 * Calculates the total dietary fiber content based on provided ingredients.
 */
export function calculateTotalFiber(ingredients: Ingredients): number | null {
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalFiber = [...ingredients].reduce(addFiber, 0);

  return Math.round(totalFiber);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.dietaryFiberG !== 'number';
}

function addFiber(total: number, ingredient: Ingredient): number {
  const fiber = typeof ingredient.dietaryFiberG === 'number' ? ingredient.dietaryFiberG : 0; // prettier-ignore
  const quantity = ingredient.quantity ?? 1;

  return total + fiber * quantity;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Ingredient = { dietaryFiberG: number | null; quantity?: number };
type Ingredients = Ingredient[] | readonly Ingredient[];
